export var FontFamilies = [
    'System',
    'Josefin Sans',
    'Lato',
    'Lora',
    'Merriweather',
    'Montserrat',
    'Noto Sans',
    'Noto Serif',
    'Open Sans',
    'Open Sans Condensed',
    'Oswald',
    'Overpass',
    'Playfair Display',
    'Poppins',
    'PT Sans',
    'PT Serif',
    'Raleway',
    'Roboto',
    'Roboto Condensed',
    'Roboto Slab',
    'Slabo 27px',
    'Ubuntu',
];
export var FontWeights = [
    'normal',
    'bold',
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
];
export var BorderTypes = ['unset', 'solid', 'dotted', 'dashed'];
export var UList = ['circle', 'square', 'disc', 'none'];
export var OList = [
    'decimal',
    'lower-roman',
    'upper-roman',
    'lower-greek',
    'lower-latin',
    'upper-latin',
    'none',
];
export var elements = [
    { value: 'h1', label: 'H1 Heading' },
    { value: 'h2', label: 'H2 Heading' },
    { value: 'h3', label: 'H3 Heading' },
    { value: 'h4', label: 'H4 Heading' },
    { value: 'h5', label: 'H5 Heading' },
    { value: 'h6', label: 'H6 Heading' },
    { value: 'p', label: 'Paragraph' },
    { value: 'strong', label: 'Strong' },
    { value: 'a', label: 'Link' },
    { value: 'blockquote', label: 'Blockquote' },
    { value: 'ul', label: 'Unordered Lists' },
    { value: 'ol', label: 'Ordered Lists' },
    { value: 'img', label: 'Image' },
    { value: 'video', label: 'Video' },
    { value: 'iframe', label: 'Iframe' },
    { value: 'figure', label: 'Figure' },
    { value: 'figcaption', label: 'Figure Caption' },
];
export var UListText = [
    { value: '1', label: 'This is an unordered list' },
    { value: '2', label: 'This is a second bullet point' },
    { value: '3', label: 'This is another bullet point' },
];
export var OListText = [
    { value: '1', label: 'This is an ordered list' },
    { value: '2', label: 'This is a second bullet point' },
    { value: '3', label: 'This is another bullet point' },
];
export var designElements = [
    { value: 'h1', label: 'H1 Heading' },
    { value: 'h2', label: 'H2 Heading' },
    { value: 'h3', label: 'H3 Heading' },
    { value: 'h4', label: 'H4 Heading' },
    { value: 'h5', label: 'H5 Heading' },
    { value: 'h6', label: 'H6 Heading' },
    { value: 'p', label: 'Paragraph' },
    { value: 'strong', label: 'Strong' },
    { value: 'a', label: 'Link' },
    { value: 'blockquote', label: 'Blockquote' },
    { value: 'ul', label: 'Unordered Lists' },
    { value: 'ol', label: 'Ordered Lists' },
    { value: 'img', label: 'Image' },
    { value: 'video', label: 'Video' },
    { value: 'iframe', label: 'Iframe' },
];
export var defaultStyles = {
    h1: {
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        fontSize: 32,
        lineHeight: 38,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#252525',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    h2: {
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        fontSize: 24,
        lineHeight: 33,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#252525',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    h3: {
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        fontSize: 21,
        lineHeight: 22,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#252525',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    h4: {
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        fontSize: 16,
        lineHeight: 19,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#252525',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    h5: {
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        fontSize: 13,
        lineHeight: 16,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#252525',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    h6: {
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        fontSize: 11,
        lineHeight: 16,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#252525',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    p: {
        fontFamily: 'Open Sans',
        fontWeight: 'normal',
        fontSize: 16,
        lineHeight: 16,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#252525',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    strong: {
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        fontSize: 16,
        lineHeight: 24,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#252525',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    blockquote: {
        fontFamily: 'Open Sans',
        fontWeight: 'normal',
        fontSize: 12,
        lineHeight: 16,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#252525',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    a: {
        fontFamily: 'Open Sans',
        fontWeight: 'normal',
        fontSize: 16,
        lineHeight: 16,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#3C8EFD',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'underline',
        letterSpacing: 0,
        textTransform: 'none',
    },
    ol: {
        listStyleType: 'decimal',
        fontFamily: 'Open Sans',
        fontWeight: '400',
        fontSize: 16,
        lineHeight: 16,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 40,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#353535',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    ul: {
        listStyleType: 'disc',
        fontFamily: 'Open Sans',
        fontWeight: '400',
        fontSize: 16,
        lineHeight: 16,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 40,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#353535',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    img: {
        width: 340,
        height: 200,
        resizeMode: 'cover',
    },
    video: {
        width: 600,
        height: 200,
        resizeMode: 'cover',
    },
    figure: {
        width: 0,
        height: 0,
        minWidth: 340,
        minHeight: 270,
    },
    figcaption: {
        fontFamily: 'Open Sans',
        fontWeight: 'normal',
        fontSize: 16,
        lineHeight: 16,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        borderTopWidth: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        color: '#252525',
        textAlign: 'left',
        fontStyle: 'normal',
        textDecorationLine: 'none currentColor solid auto',
        letterSpacing: 0,
        textTransform: 'none',
    },
    iframe: {
        width: 340,
        height: 240,
    },
};
